import {Component} from '@angular/core';
import {ClientConfiguration} from '@twpub/core/utils';

import {ConfigurationListComponent} from '../configuration-list/configuration-list.component';
import {EditConfigurationFormComponent} from '../edit-configuration-form/edit-configuration-form.component';

@Component({
  selector: 'pub-configurations-panel',
  templateUrl: './configurations-panel.component.html',
  styleUrls: ['./configurations-panel.component.scss'],
  standalone: true,
  imports: [ConfigurationListComponent, EditConfigurationFormComponent]
})
export class ConfigurationsPanelComponent {
  private _editConfiguration?: ClientConfiguration;
  get editConfiguration(): ClientConfiguration | undefined {
    return this._editConfiguration;
  }

  set editConfiguration(value: ClientConfiguration | undefined) {
    this._editConfiguration = value?.clone();
  }

  editingDone() {
    this._editConfiguration = undefined;
  }
}
